<script setup lang="ts">
  import { computed } from 'vue'

  import UserIcon from '@shared/components/user-icon.vue'

  const props = defineProps<{
    modelValue?: number | string | boolean | string[]
    value?: string | boolean
    label?: string
    title?: string
    errorMsg?: string[]
    isUserIcon?: boolean
    isDescription?: boolean
    description?: string
  }>()
  const emit = defineEmits(['update:modelValue', 'on-change'])

  const checkboxVal = computed({
    get() {
      return props.modelValue || props.value
    },
    set(newVal) {
      emit('update:modelValue', newVal)
    },
  })
</script>

<template>
  <el-form-item :class="{ 'has-error': errorMsg }">
    <el-checkbox v-model="checkboxVal" :label="label" v-bind="$attrs">
      <template #default>
        <div class="tw-flex tw-items-center">
          <span v-if="isUserIcon" class="tw-mr-10">
            <user-icon :full-name="title || label" :string-color="label" />
          </span>
          <span> {{ title || label }}</span>
        </div>
        <p v-if="isDescription" class="tw-mt-8 tw-text-body-2">{{ description }}</p>
      </template>
    </el-checkbox>
    <div v-if="errorMsg" class="tw-mt-8 tw-text-accent-500 tw-text-caption-1">{{ errorMsg[0] }}</div>
  </el-form-item>
</template>

<style lang="scss">
  @use '@shared/scss/ui/_checkbox.scss' as *;
</style>
